import React, { useState } from "react";
import styled from "styled-components";

import { State } from "src/state/ducks";
import { messageInitialEntity } from "src/firebase/db/Messages";

import StyleConfig from "src/constants/StyleConfig";

import Button from "src/components/atoms/button/Button";
import HomeButton from "src/components/atoms/button/HomeButton";
import CheckBox from "src/components/atoms/form/CheckBox";
import SelectBox from "src/components/atoms/form/SelectBox";

import { AnnotaionText } from "src/components/atoms/form/AnnotationText";
import InputLabelHolder from "src/components/molecules/form/InputLabelHolder";
import TextArea from "src/components/atoms/form/TextArea";

import { ValidateMessageIfError } from "src/components/atoms/form/ErrorMessage";
import SingleInputFormBlock from "src/components/molecules/form/SingleInputFormBlock";

import { useEffect } from "react";
import MyDatePicker from "src/components/atoms/form/MyDatePicker";

type MessageMenu = State["master"]["messages"][number];

type Props = {
  formType: "CREATE" | "UPDATE";
  message: MessageMenu;
  errors: State["shop"]["validationErrors"];
  onSubmit: (query: MessageMenu) => void;
};

const mapEntityToState = (entity: MessageMenu) => {
  return {
    title: entity.title,
    body: entity.body,
    has_sound: entity.has_sound,
    send_time: entity.send_time,
    publish_status: entity.publish_status,
    zendesk_url: entity.zendesk_url,
  };
};

const mapStateToEntity = (
  prevEntity: MessageMenu,
  state: ReturnType<typeof mapEntityToState>
): MessageMenu => ({
  ...prevEntity,
  title: state.title,
  body: state.body,
  has_sound: state.has_sound,
  send_time: state.send_time,
  publish_status: state.publish_status,
  zendesk_url: state.zendesk_url,
});

const PushNotificationForm = (props: Props) => {
  const { message, errors, onSubmit } = props;
  const [state, setState] = useState(mapEntityToState(messageInitialEntity));

  useEffect(() => {
    setState(mapEntityToState(message));
  }, [message]);

  const handleSubmit = () => {
    onSubmit(mapStateToEntity(message, state));
  };

  return (
    <Form>
      <div className="item">
        <SingleInputFormBlock
          isRequired
          labelName="タイトル"
          inputType="text"
          inputValue={state.title}
          onChange={(title) => setState((prev) => ({ ...prev, title }))}
          placeholder="通知タイトルを明記してください"
          isError={false}
        />
        <ValidateMessageIfError marginVertical={8} messages={errors.title} />
      </div>
      <div className="item">
        <InputLabelHolder labelName="通知本文" isRequired />
        <TextArea
          rows={5}
          max={1000}
          inputValue={state.body}
          placeholder="通知に使用する本文を記載してください"
          onChange={(body) => setState((prev) => ({ ...prev, body }))}
          isError={false}
          isDisabeld={false}
        />
        <ValidateMessageIfError marginVertical={8} messages={errors.body} />
      </div>
      <div className="item">
        <SingleInputFormBlock
          labelName="お知らせするURL"
          inputType="text"
          inputValue={state.zendesk_url}
          onChange={(zendesk_url) =>
            setState((prev) => ({ ...prev, zendesk_url }))
          }
          placeholder="今回表示するURLを記載してください"
          isError={false}
        />
        <ValidateMessageIfError
          marginVertical={8}
          messages={errors.zendesk_url}
        />
      </div>
      <div className="item">
        <InputLabelHolder labelName="送信時刻" isRequired />
        <MyDatePicker
          date={state.send_time}
          timeInterval={5}
          onChange={(send_time) => setState((prev) => ({ ...prev, send_time }))}
        />
        <ValidateMessageIfError
          marginVertical={8}
          messages={errors.send_time}
        />
      </div>
      <div className="item">
        <div className="input_block">
          <InputLabelHolder labelName="通知音" isRequired />
          <CheckBox
            children={"通知音を鳴らす"}
            isChecked={state.has_sound}
            onChange={() => {
              const has_sound = !state.has_sound;
              setState((prev) => ({ ...prev, has_sound }));
            }}
          />
        </div>
        <AnnotaionText text={"※基本はONです"} />
        <ValidateMessageIfError
          marginVertical={8}
          messages={props.errors.has_sound}
        />
      </div>
      <div className="item">
        <InputLabelHolder labelName="公開状況" isRequired />
        <SelectBox
          id="publish_staus"
          inputValue={state.publish_status}
          onChange={(publish_status) =>
            setState((prev) => ({ ...prev, publish_status }))
          }
          options={[
            { value: "0", content: "下書き" },
            { value: "1", content: "送信予約" },
            { value: "2", content: "送信済み" },
          ]}
        />
        <AnnotaionText
          text={"※送信予約かつ送信時刻が未来のもののみ送信されます"}
        />
      </div>
      <div className="submit">
        <div className="submit-item">
          <Button
            type="button"
            isDisabled={false}
            clickEvent={handleSubmit}
            text="通知を予約する"
          />
        </div>
        <div className="submit-item mt20">
          <HomeButton />
        </div>
      </div>
    </Form>
  );
};

const Form = styled.form`
  > .item {
    margin: ${StyleConfig.HELPER.M24} auto;
  }
  .mt8 {
    margin-top: ${StyleConfig.HELPER.M8};
  }
  > .submit {
    padding: ${StyleConfig.HELPER.M48} 0;
    .mt20 {
      margin-top: ${StyleConfig.HELPER.M20};
    }
  }
  .hashtag {
    > li {
      display: inline-block;
      margin: 0 ${StyleConfig.HELPER.M16} ${StyleConfig.HELPER.M16} 0;
    }
  }
`;

export default PushNotificationForm;
